'use strict';

function modaalFunction(g) {
  function init() {
    $('.js-open-modaal-contrat').modaal({
      custom_class: 'modaal-wrapper--contrat',
      background: '#4071ac',
      overlay_opacity: '.9',
      content_source: '#modaal-contrat'
    });

    $('.js-open-modaal-demo-styleguide').modaal({
      background: '#4071ac',
      overlay_opacity: '.9',
      content_source: '#modaal-demo-styleguide'
    });

    $('.js-modaal-gallery').modaal({
      type: 'image',
      background: '#4071ac',
      overlay_opacity: '.9',
      after_open: function() {
        $('.modaal-gallery-control').addClass('btn btn--icon btn--icon-only');
      }
    });

    $('.js-modaal-wrapper-legals').modaal({
      // type: 'image',
      background: '#4071ac',
      overlay_opacity: '0',
      custom_class: 'modaal-wrapper--legals'
    });

    $('.js-modaal-video-header').modaal({
      type: 'ajax',
      background: '#4071ac',
      overlay_opacity: '.9',
      custom_class: 'modaal-wrapper--video'
    });

    $('.js-open-modaal-connexion').modaal({
      background: '#0052ca',
      overlay_opacity: '1',
      custom_class: 'modaal-wrapper--connexion',
      fullscreen: true,
      content_source: '#modaal-connexion'
    });

    reloadOnCloseModal();
  }

  function reloadOnCloseModal() {
    // Lorsque qu'on clicque sur la fermeture de la modale de connexion, on recharge la page pour vérifier le cookie
    $(document).on('click', '.modaal-wrapper--connexion .modaal-close', function(e) {
      document.location.reload(true);
    });
  }

  init();
}
